import React, { useEffect, useRef, useState } from 'react';
import GroupedItemsContainer from './GroupedItemsContainer';
import groupBy from '../../widgets/SearchTourForm/utils/groupBy';

const SearchDropdownMultiselectList = ({ items, value, onChoose }) => {
  const [openGroup, setOpenGroup] = useState(null);

  const groupedItems = groupBy(items, ({ group }) => group);
  const groupsList = Object.keys(groupedItems);

  const handleGroupToggle = (groupName) => {
    setOpenGroup((prevOpenGroup) =>
      prevOpenGroup === groupName ? null : groupName
    );
  };

  return (
    <div className="popup-body fixed">
      <div className="popup-body__items">
        {groupsList.map((groupName) => (
          <GroupedItemsContainer
            key={groupName}
            groupName={groupName}
            groupedItems={groupedItems}
            value={value}
            onChoose={onChoose}
            isOpen={openGroup === groupName}
            onToggle={() => handleGroupToggle(groupName)}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchDropdownMultiselectList;
